import { useCallback, useState, useEffect } from "react";
import useEvent from "./use-event";
import { WEBSOCKET_EVENT_TYPE } from "constants/ChatConstants";
import { MESSAGE_EVENTS } from "constants/ChatConstants";
import { useDispatch } from "react-redux";
import { parseWSData } from "util/UtilityFunctions";
import { chatAction } from "store/chat-slice";
import { messageAction } from "store/message-slice";

const useMessageQueue = () => {

  const dispatch = useDispatch();
  const [messageQueue, setMessageQueue] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const { onEventReceive } = useEvent();

  const processMessage = useCallback(
    async (message) => {
      try {
        console.info("Running onMessageReceiveEvent fn...");
        const payload = parseWSData(message.body);
        if (payload.ws_type === WEBSOCKET_EVENT_TYPE.SMS_MESSAGE) {
          onEventReceive(WEBSOCKET_EVENT_TYPE.SMS_MESSAGE, payload.message);
          return;
        } else if (payload.ws_type === MESSAGE_EVENTS.CONVERSATION_ASSIGNED) {
          console.log(payload);
          onEventReceive(MESSAGE_EVENTS.CONVERSATION_ASSIGNED, payload);
          return;
        } else if (payload.ws_type === MESSAGE_EVENTS.CONVERSATION_UNASSIGNED) {
          console.log(payload);
          onEventReceive(MESSAGE_EVENTS.CONVERSATION_UNASSIGNED, payload);
          return;
        } else if (payload.ws_type === WEBSOCKET_EVENT_TYPE.SMS_READ) {
          dispatch(
            chatAction.updateUnreadCount({
              recipientId: payload.recipientId,
              count: -payload.ids.length,
            })
          );
          dispatch(messageAction.updateMessageAsRead(payload));
          return;
        } else if (payload.ws_type === WEBSOCKET_EVENT_TYPE.WA_MESSAGE_STATUS) {
          // Handle WA message status
        } else if (payload.ws_type === WEBSOCKET_EVENT_TYPE.MESSAGE_STATUS) {
          dispatch(messageAction.updateMessageStatus(payload.message));
          return;
        } else if (payload.ws_type === WEBSOCKET_EVENT_TYPE.SMS_UNREAD) {
          dispatch(
            chatAction.updateUnreadCount({
              recipientId: payload.recipientId,
              count: payload.count,
            })
          );
          dispatch(
            chatAction.setTotalUnreadCount({ count: payload.totalCount })
          );
          dispatch(
            messageAction.markLastMessageReadByNull(payload.recipientId)
          );
        }
      } catch (e) {
        console.log(e);
      }
    },
    [onEventReceive, dispatch]
  );

  useEffect(() => {
    if (messageQueue.length > 0 && !isProcessing) {
      setIsProcessing(true);
      const message = messageQueue[0];
      processMessage(message).then(() => {
        setMessageQueue((prevQueue) => prevQueue.slice(1));
        setIsProcessing(false);
      });
    }
  }, [messageQueue, isProcessing, processMessage]);

  const enqueueMessage = useCallback((message) => {
    setMessageQueue((prevQueue) => [...prevQueue, message]);
  }, []);

  return enqueueMessage;
};
export default useMessageQueue;